export default "<div class=\"header font--roboto\">\n    <div class=\"header-title\">\n        <p>Julian Cutajar</p> | We live in Malta\n    </div>\n</div>\n"